<div class="menu">
  <span class="menu-heading">{{ Heading }}</span>
  <span class="close" (click)="closeTaskSelectionMenu()">X</span>
</div>
<div class="container m-0 p-0" *ngIf="ChangeArray?.length; else elsePart">
  <div class="console">
    <div class="accordion" id="accordion-menus" class="p-0 m-0">
      <accordion [closeOthers]="true">
        <accordion-group *ngFor="let item of ChangeArray; let i = index" #groupVal [isOpen]="i == 0">
          <!-- <button
            class="btn btn-block justify-content-between d-flex w-100 collapse-btn"
            accordion-heading
            type="button"
          > -->
          <div class="row collapse-btn" accordion-heading>
            <div class="col-9">
              <span class="arrow">
                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-expand-ar.png"
                  style="width: 13px; padding: 0px 2px 4px 0"
                  *ngIf="groupVal?.isOpen"
                />

                <img
                  class="collapse-expang-img"
                  src="{{ baseHref }}/assets/images/icon-collapse-ar.png"
                  style="width: 13px; padding: 0px 2px 4px 0"
                  *ngIf="!groupVal?.isOpen"
                />
              </span>
              <span class="menu-item">{{ item.User?.FirstName || "Onvida"}} {{ item.User?.LastName || "API" }}
                <span class="sub-menu-item" *ngIf="item.User?.Email">({{ item.User?.Email }})</span>
              </span>
            </div>
            <div class="col-3"   style="padding: 0 0 0 60px;"  >
              <span class="count">{{ item.Changes.length }}</span>
              <span class="date">{{ item.Date | custdate }} </span>
            </div>
            <hr class="solid-headerDivider" />
          </div>

          <!-- </button> -->
          <!-- <hr class="solid-headerDivider" /> -->

          <div class="tbodyDiv m-2" *ngFor="let it of item.Changes; let i = index">
            <!-- <table class="table table-hover table-striped text-center">
                            <thead class="sticky-top bg-white">
                                <tr class="table-heading">
                                    <th scope="col">Queue Type</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Dialer Type</th>
                                    <th scope="col">Records</th>
                                </tr>
                            </thead>
                            <tbody class="table-values">
                                <tr *ngFor="let it of item.data">
                                    
                                <td>Field</td>
                                <td>{{it.name}}</td>
                                <td>{{it.dialertype}}</td>
                                <td>{{it.countLabel}}</td>

                            </tr>
                        </tbody>
                    </table> -->
            <div class="row mb-2">
              <div class="col-1 index">{{ i + 1 }}.</div>
              <div class="col-1 field">Field:</div>
              <div class="col field-value">{{ it.Field }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-1 index"></div>
              <div class="col-1 field">From:</div>
              <div class="col-10 field" [innerHtml]="getSafeHtml(it.PreviousValue)" *ngIf="isHtmlContent(it?.PreviousValue); else showHtmlOldContent" ></div>
              <ng-template #showHtmlOldContent>
                <div class="col field" >{{ it.PreviousValue ? it.PreviousValue : '-' }}</div>
              </ng-template>
            </div>
            <div class="row mb-3">
              <div class="col-1 index"></div>
              <div class="col-1 field">To:</div>
              <div class="col-10 field" [innerHtml]="getSafeHtml(it.Value)" *ngIf="isHtmlContent(it?.Value); else showHtmlNewContent" ></div>
                <ng-template #showHtmlNewContent>
                  <div class="col field">{{ it.Value ? it.Value : 'NULL' }}</div>
                </ng-template>
            </div>
            <!-- <div class="row" style="width: 100%">
              
              <label class="table-heading col-2">Field:</label>
              <input class="table-values col-10" readonly value="{{ it.Field }}" />
            </div>
            <div class="row" style="width: 100%">
              <label class="table-heading col-2">From:</label>
              <input class="table-values col" readonly value="{{ it.PreviousValue ? it.PreviousValue : 'null' }}" />
            </div>
            <div class="row" style="width: 100%">
              <label class="table-heading col-2">To:</label>
              <input class="table-values col" readonly value="{{ it.Value }}" />
            </div> -->
          </div>
        </accordion-group>
      </accordion>
    </div>
  </div>
</div>
<ng-template #elsePart>
  <div class="fs-5 fw-bold container">No changes have been made to this case.</div>
</ng-template>
